// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ZtF5d","signatureBlock":"Footer_signatureBlock__2EX3s","signature":"Footer_signature__3sUSv"};